// live endpoint
const SERVER_ENDPOINT = "https://dotnet.hordecall.net";
// const SERVER_ENDPOINT = "https://joatech.hordecall.net"

// test endpoint
// const SERVER_ENDPOINT = "https://dotnetdev.hordecall.net";

export const API_ROUTES = {
  LOG_IN: `${SERVER_ENDPOINT}/api/login`,

  GET_ALL_COMPANY: `${SERVER_ENDPOINT}/api/get/company/users`,

  GET_A_SINGLE_COMPANY_MARKETER: `${SERVER_ENDPOINT}/api/marketer/`,
  UPDATE_COMPANY_MARKETER: `${SERVER_ENDPOINT}/api/marketer`,
  DELETE_COMPANY_MARKETER: `${SERVER_ENDPOINT}/api/marketer`,
  GET_ALL_COMPANY_MARKETER: `${SERVER_ENDPOINT}/api/marketer/`,
  CREATE_MARKETER: `${SERVER_ENDPOINT}/api/marketer`,

  GET_MAIN_DASHBOARD: `${SERVER_ENDPOINT}/api/marketer-log`,
  GET_COMPANY_DASHBOARD: `${SERVER_ENDPOINT}/api/marketer-log/companies`,
  GET_SINGLE_MARKETER_DASHBOARD: `${SERVER_ENDPOINT}/api/marketer-log/marketers`,
  GET_SINGLE_COMPANY_DASHBOARD: `${SERVER_ENDPOINT}/api/marketer-log/companies`,
  CREATE_COMPANY: `${SERVER_ENDPOINT}/api/register`,
  UPDATE_COMPANY: `${SERVER_ENDPOINT}/api`,
  DELETE_COMPANY: `${SERVER_ENDPOINT}/api`,
  TEST_MODE: `${SERVER_ENDPOINT}/api/SubscriptionStatus/by-msisdn`,
  FILTER_DATA: `${SERVER_ENDPOINT}/api/marketer-log/filter-stats`,
  PRODUCT_DAILY_BREAKDOWN: `${SERVER_ENDPOINT}/api/marketer-log/PerMarketerStats`,
  GET_GAMES: `${SERVER_ENDPOINT}/api/marketer-log/getGames`,

  // Product routes
  GET_ALL_PRODUCTS: `${SERVER_ENDPOINT}/api/Product`,
  CREATE_PRODUCT: `${SERVER_ENDPOINT}/api/Product`,
  UPDATE_PRODUCT: `${SERVER_ENDPOINT}/api/Product`,
  DELETE_PRODUCT: `${SERVER_ENDPOINT}/api/Product`,
  ACTIVATE_PRODUCT: `${SERVER_ENDPOINT}/api/Product/update-running`,
};
